export default __webpack_public_path__ + "42c773fef414005c87d7f26619a3ed5f.png";